import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowButton from '../../../../../components/arrow-button';
import { ActionCreateTasksVariants } from '../../../../../modules/action-create/task-variants';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { useActionTaskVariants } from '../hooks/use-action-task-variants';
import { actionTaskVariants } from '../utils/action-tasks';

const LavvaActionCreateTaskVariants: React.FC = () => {
  const { t } = useTranslation('action');
  const { selectTaskVariant, getChannelsByVariant } = useActionTaskVariants();
  const { channelList } = useDevicesAndChannelsContext();

  const filteresActionTasks = useMemo(() => {
    return actionTaskVariants.filter((v) => getChannelsByVariant(v.variant).length);
  }, [actionTaskVariants, channelList]);

  return (
    <ActionCreateTasksVariants listCount={filteresActionTasks.length}>
      {filteresActionTasks.map((x) => (
        <ArrowButton
          key={x.title}
          title={t(x.title)}
          icon={x.icon}
          iconAccent
          className="m-b-24"
          onClick={() => selectTaskVariant(x.variant)}
        />
      ))}
    </ActionCreateTasksVariants>
  );
};

export default LavvaActionCreateTaskVariants;
